import React, { memo, useCallback } from 'react';
import { API_BASE_URL } from '../../store/constans';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-scroll';

const Banner = ({ children, state, buttons, to, smooth }) => {
    const navigate = useNavigate();

    const handleNavigate = useCallback((path) => {
        navigate(path);
    }, [navigate]);

    return (
        <div className="flex md:justify-end transition-all h-screen relative">
            {/* Imagen con lazy loading */}
            <img
                className="absolute top-0 left-0 w-full h-full object-cover"
                loading="lazy"
                src={`${API_BASE_URL}${state.baner?.image}`}
                alt={state.baner?.title || "Imagen descriptiva"} // Mejor alt
            />
            {/* Overlay oscuro */}
            <div className="absolute top-0 left-0 w-full h-full bg-black/30" />

            {/* Contenedor de texto */}
            <div className="flex px-5 flex-col z-10 transition-all md:justify-center text-white pt-32 md:pb-10 md:w-[55%] w-full">
                <div className="p-5 flex flex-col justify-center items-center">
                    <div className="z-20 mb-[-30px]">
                        <h1 className="text-[4rem] md:text-[4.5rem] leading-none text-amber-500 text-center md:text-left text-shadow-lg" style={{ fontFamily: 'BloomingHeart' }}>
                            {state.baner?.title}
                        </h1>

                    </div>
                    <div className="flex flex-col mb-8 text-white uppercase justify-center items-center">
                        <h2 className="font-bold text-[35px] md:text-[55px] leading-none text-shadow-lg">
                            {state.baner?.subTitle}
                        </h2>
                        <p className="font-bold text-[13px] md:text-[15px] leading-none text-shadow-lg">
                            {state.baner?.text}
                        </p>
                    </div>
                </div>

                {/* Botones */}
                {buttons === 'home' ? (
                    <HomeButtons handleNavigate={handleNavigate} />
                ) : smooth ? (
                    <SmoothScrollLink to={to}>{children}</SmoothScrollLink>
                ) : (
                    <DefaultButton to={to} handleNavigate={handleNavigate}>{children}</DefaultButton>
                )}
            </div>
        </div>
    );
};

const HomeButtons = ({ handleNavigate }) => (
    <>
        <div className="flex gap-3 justify-center mb-3">
            <Button onClick={() => handleNavigate("/galapagos-cruises")}>Galapagos Cruises</Button>
            <Button onClick={() => handleNavigate("/last-minute-deals")}>Last Minute Deals</Button>
        </div>
        <div className="flex gap-3 justify-center">
            <Button onClick={() => handleNavigate("/last-minute-deals")}>Check Availability</Button>
        </div>
    </>
);

const SmoothScrollLink = ({ to, children }) => (
    <div className="flex gap-3 justify-center mb-3">
        <Link
            to={to}
            smooth={true}
            duration={800}
            className="cursor-pointer transition-all hover:scale-110 shadow-md shadow-black text-[13px] md:text-[18px] border border-white px-5 py-2 font-bold rounded-full hover:text-white hover:bg-orange-500"
        >
            {children}
        </Link>
    </div>
);

const DefaultButton = ({ to, handleNavigate, children }) => (
    <div className="flex gap-3 justify-center mb-3">
        <Button onClick={() => handleNavigate(to)}>{children}</Button>
    </div>
);

const Button = ({ onClick, children }) => (
    <button
        onClick={onClick}
        className="transition-all hover:scale-110 shadow-md shadow-black text-[13px] md:text-[18px] border border-white px-5 py-2 font-bold rounded-full hover:text-white hover:bg-orange-500"
    >
        {children}
    </button>
);

export default memo(Banner);
